import React, { useState } from 'react';
import { BestsellerContainer } from './styled';
import ProductCardHome from './ProductCardHome';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { useRouter } from 'next/router';
import { getSearchParams } from '../../Parenting/common';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { fireEvent } from '../../../Utils/fireEvent';
import { getScreenName } from '../../../Utils/helper';

function BestsellerNew(props) {
  const { categoryData, setChangeCartCount } = props;
  const [cardEffect, setCardEffect] = useState();
  const router = useRouter();
  const [selectedCategory, setSelectedCategory] = useState(0);

  const callbackFunction = (index, element) => {
     const currentCat = categoryData?.items?.[selectedCategory];
    // fire click event for "View all"
    if (currentCat) {
      fireEvent({
        category: 'clicked_card_in_store_home',
        screen_name: getScreenName(),
        section_id: categoryData?._id || null,
        section_name: categoryData?.heading || categoryData?.itemType || 'bestseller_section',
        card_id: currentCat?._id || currentCat?.id || null,
        card_name: currentCat?.tabName || currentCat?.heading || 'view_all',
        shape: 'VIEW_ALL',
        position: selectedCategory,
        deeplink: element,
        deeplink_value: element,
        query_params: typeof window !== 'undefined' ? window.location.search || 'NA' : 'NA',
        page_url: typeof window !== 'undefined' ? window.location.href.slice(0, 99) : 'NA',
      });
    }

    setCardEffect({ index: index, effect: 'lowOpacity' });
    setTimeout(() => {
      router.push(`${element}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };

  const onClickCategory = (i) => {
    setSelectedCategory(i);
    const cat = categoryData?.items?.[i];
    if (!cat ) return;

    fireEvent({
      category: 'clicked_card_in_store_home',
      screen_name: getScreenName(),
      section_id: categoryData?._id || null,
      section_name: categoryData?.heading || categoryData?.itemType || null,
      card_id: cat?._id || cat?.id || null,
      card_name: cat?.tabName || cat?.heading || 'category_tab',
      shape: 'CATEGORY_TAB',
      position: i,
      deeplink: cat?.webUrl || cat?.deeplinkValue || null,
      deeplink_value: cat?.webUrl || cat?.deeplinkValue || null,
      query_params: typeof window !== 'undefined' ? window.location.search || 'NA' : 'NA',
      page_url: typeof window !== 'undefined' ? window.location.href.slice(0, 99) : 'NA',
    });
  };

  return (
    <BestsellerContainer>
      <p className="desktopHead">
        <span className="bestseller">Bestsellers </span>
      </p>

      <div className="elementContainer">
        {categoryData?.items?.map((item, i) => {
          return (
            <div key={`ele-${i}`}>
              <div
                onClick={() => onClickCategory(i)}
                className={`tabContainer ${
                  selectedCategory == i ? 'selected' : ''
                }`}
              >
                <p>{item?.tabName}</p>
              </div>
              <div
                className={selectedCategory == i ? 'triangleDown' : ''}
              ></div>
            </div>
          );
        })}
      </div>
      <div className="productContainer">
        {categoryData?.items?.[selectedCategory]?.items?.map(
          (element, index) => {
            return (
              <ProductCardHome
                itemId={`element-${index}`}
                productInfo={element}
                setChangeCartCount={setChangeCartCount}
                key={`element-${element?._id}${index}`}
                store={true}
                section={categoryData} // pass section
                isParentingPage={false} // if needed
      
                
              />
            );
          },
        )}
      </div>

      {categoryData?.items?.[selectedCategory]?.webUrl && (
        <div className="viewAllButton">
          <AnchorCoverTag
            url={categoryData?.items?.[selectedCategory]?.webUrl}
            cardEffect={cardEffect?.index === 0 ? 'lowOpacity' : ''}
            callbackFunction={() =>
              callbackFunction(
                0,
                categoryData?.items?.[selectedCategory]?.webUrl,
              )

            }
          >
            <p>View all</p>
          </AnchorCoverTag>
        </div>
      )}
    </BestsellerContainer>
  );
}

export default BestsellerNew;
